import { createFileRoute } from '@tanstack/react-router';
import { PublicTransmittalPage } from '@/features/transmittals/pages/public-transmittal-page';

/**
 * Public: the link of a transmittal e-mail (`/t/{token}`). No session and no app shell: the page
 * only calls the public transmittal endpoints, and its code loads as its own chunk.
 */
export const Route = createFileRoute('/t/$token')({
  component: PublicTransmittalRoute,
});

function PublicTransmittalRoute() {
  const { token } = Route.useParams();
  return <PublicTransmittalPage token={token} />;
}
